var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import React, { useMemo } from 'react';
import { useIntl } from 'react-intl';
import * as yup from 'yup';
import { useFormik } from 'formik';
import { Button, Drawer, DrawerActions, DrawerContent, DrawerHeader, } from '@petsly/shared-client';
import { useDrawer } from 'context/DrawerContext';
import sharedMessages from 'translations/shared';
import { ServiceStatusEnum, ServicePriceTypeEnum, } from 'types/graphql';
import NameField from './components/NameField';
import CategoriesField from './components/CategoriesField';
import AmountField from './components/AmountField';
import DurationField from './components/DurationField';
import DescriptionField from './components/DescriptionField';
import IsOnlineField from './components/IsOnlineField';
import IsTravellingField from './components/IsTravellingField';
import NoteToCustomerField from './components/NoteToCustomerField';
import AllowBookingField from './components/AllowBooking';
import EmployeesField from './components/EmployeesField';
var View = function (_a) {
    var isProcessing = _a.isProcessing, onCreate = _a.onCreate, error = _a.error, categories = _a.categories, employees = _a.employees;
    var closeDrawer = useDrawer().closeDrawer;
    var formatMessage = useIntl().formatMessage;
    var Ids = useMemo(function () { return employees.map(function (entry) { return entry.id; }); }, [employees]);
    var validationSchema = useMemo(function () {
        return yup.object().shape({
            name: yup.string().required(formatMessage(sharedMessages.required)),
            category: yup.string().nullable(),
            description: yup.string().nullable(),
            noteToCustomer: yup.string().nullable(),
            amount: yup.number().required(formatMessage(sharedMessages.required)),
            duration: yup.number().required(formatMessage(sharedMessages.required)),
            isOnlineService: yup.boolean(),
            allowBooking: yup.boolean(),
            isTravellingService: yup.boolean(),
            employeeIds: yup
                .array()
                .of(yup.string().required(formatMessage(sharedMessages.required))),
        });
    }, []);
    var formik = useFormik({
        validationSchema: validationSchema,
        enableReinitialize: true,
        initialValues: {
            name: '',
            category: null,
            description: null,
            noteToCustomer: null,
            amount: 0,
            duration: 0,
            isOnlineService: false,
            isTravellingService: false,
            allowBooking: true,
            status: ServiceStatusEnum.Active,
            priceType: ServicePriceTypeEnum.Fixed,
            employeeIds: Ids,
        },
        onSubmit: function (values) {
            onCreate({
                name: values.name,
                categoryId: values.category,
                description: values.description,
                noteToCustomer: values.noteToCustomer,
                amount: values.amount * 100,
                duration: +values.duration,
                status: ServiceStatusEnum.Active,
                priceType: ServicePriceTypeEnum.Fixed,
                isOnlineService: values.isOnlineService,
                isTravellingService: values.isTravellingService,
                allowBooking: values.allowBooking,
                employeeIds: values.employeeIds,
            });
        },
    });
    var submitForm = formik.submitForm, values = formik.values, errors = formik.errors, touched = formik.touched, setFieldValue = formik.setFieldValue, setFieldTouched = formik.setFieldTouched;
    return (_jsxs(Drawer, __assign({ open: true, onDismiss: closeDrawer }, { children: [_jsx(DrawerHeader, __assign({ onClose: closeDrawer }, { children: formatMessage(sharedMessages.addService) }), void 0), _jsxs(DrawerContent, { children: [_jsx(NameField, { value: values.name, error: errors.name, touched: touched.name, onChange: function (value) { return setFieldValue('name', value); }, onBlur: function () { return setFieldTouched('name'); } }, void 0), _jsx(CategoriesField, { categories: categories, value: values.category, error: errors.category, onChange: function (value) { return setFieldValue('category', value); }, onBlur: function () { return setFieldTouched('category'); } }, void 0), _jsx(AmountField, { value: values.amount, error: errors.amount, touched: touched.amount, onChange: function (value) { return setFieldValue('amount', value); }, onBlur: function () { return setFieldTouched('amount'); } }, void 0), _jsx(DurationField, { value: values.duration, error: errors.duration, touched: touched.duration, onChange: function (value) { return setFieldValue('duration', value); }, onBlur: function () { return setFieldTouched('duration'); } }, void 0), _jsx(DescriptionField, { value: values.description, error: errors.description, touched: touched.description, onChange: function (value) { return setFieldValue('description', value); }, onBlur: function () { return setFieldTouched('description'); } }, void 0), _jsx(EmployeesField, { value: values.employeeIds, error: errors.employeeIds, employees: employees, touched: touched.employeeIds, onChange: function (value) { return setFieldValue('employeeIds', value); } }, void 0), _jsx(IsTravellingField, { value: values.isTravellingService, error: errors.isTravellingService, touched: touched.isTravellingService, onChange: function (value) { return setFieldValue('isTravellingService', value); }, onBlur: function () { return setFieldTouched('isTravellingService'); } }, void 0), _jsx(IsOnlineField, { value: values.isOnlineService, error: errors.isOnlineService, touched: touched.isOnlineService, onChange: function (value) { return setFieldValue('isOnlineService', value); }, onBlur: function () { return setFieldTouched('isOnlineService'); } }, void 0), _jsx(AllowBookingField, { value: values.allowBooking, error: errors.allowBooking, touched: touched.allowBooking, onChange: function (value) { return setFieldValue('allowBooking', value); }, onBlur: function () { return setFieldTouched('allowBooking'); } }, void 0), _jsx(NoteToCustomerField, { value: values.noteToCustomer, error: errors.noteToCustomer, touched: touched.noteToCustomer, onChange: function (value) { return setFieldValue('noteToCustomer', value); }, onBlur: function () { return setFieldTouched('noteToCustomer'); } }, void 0)] }, void 0), _jsx(DrawerActions, { children: _jsx(Button, __assign({ onClick: submitForm, disabled: isProcessing, fullWidth: true }, { children: isProcessing
                        ? formatMessage(sharedMessages.loading)
                        : formatMessage(sharedMessages.save) }), void 0) }, void 0)] }), void 0));
};
export default View;
